export default "/img/africadirect.png"